import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { history } from '../../helpers';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 25
  },
  containerMenu: {
    display: 'flex',
    alignItems: 'center',
  },
  tab: {
    paddingBottom: 15,
    paddingRight: 16,
    paddingLeft: 16,
    marginTop: 16,
    color: theme.palette.neutrals.low.light,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
  },
  active: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    color: theme.palette.neutrals.low.medium,
  },
}));

function CurationMenus() {
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <div>
        {/* {type === 'admin' && ( */}
          <div className={classes.containerMenu}>
            <div
              className={
                location.pathname === `/curation`
                  ? clsx(classes.tab, classes.active)
                  : classes.tab
              }
              onClick={() => history.push(`/curation`)}
            >
              {t('esteira_de_ideias')}
            </div>
            <div
              className={
                location.pathname === `/curation-list`
                  ? clsx(classes.tab, classes.active)
                  : classes.tab
              }
              onClick={() => history.push(`/curation-list`)}
            >
              {t('listagem_de_ideias')}
            </div>
          </div>
        {/* )} */}
      </div>
    </div>
  );
}

export { CurationMenus };
